import React, { useState, useEffect } from "react";
import { instance } from "../../axios";
import "bootstrap/dist/css/bootstrap.css";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { BgLoader, UiButton, UiInput, PageError } from "../../ui";
import { LoginUser, setStorage } from "../../helper";
import { useStore } from "../../state.js";
import { useNavigate, Link, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { toast } from "react-toastify";
import { InvoiceTemplate } from '../../invoice'


const ViewInvoice = ({ ...props }) => {
  const { auth, setAuth } = useStore((state) => state);
  let navigat = useNavigate();
  let { id } = useParams();
  const [loader, showLoader] = useState(false);


  const [state, setState] = useState({});



  const fetchData = () => {
    instance
      .get("/quick_invoice?id=" + encodeURIComponent(id))
      .then(function (response) {
        setState({ ...state, ...response.data })
      })
      .catch(function (error) { })
      .then(function () { });
  }

  const downloadPdf = (id, id1) => {
    showLoader(true)
    fetch('https://api.practive.in/pdf?voucher=invoice&id=' + id + ':' + encodeURIComponent(id1)).then(response => {
      response.blob().then(blob => {

        const fileURL = window.URL.createObjectURL(blob);

        let alink = document.createElement('a');
        alink.href = fileURL;
        alink.download = 'invoice.pdf';
        alink.click();
        showLoader(false)
      })
    })
  }

  useEffect(() => {
    fetchData()

  }, []);






  if (state.status == 'error') {
    return (
      <PageError msg={state.msg} />
    )
  }



  return (
    <div className="container">
      <Helmet>
        <title>Invoice</title>
        {state.company && state.company.logo && <link rel="icon" type="image/x-icon" href={state.company.logo}></link>}
      </Helmet>
      {loader && (
        <div className="overlay">
          <div className="overlay__inner">
            <div className="overlay__content"><span className="spinner"></span></div>
          </div>
        </div>
      )}
      <>
        {state.company ?
          <>
            <header className="navbar navbar-light sticky-top bg-white align-items-center d-flex shadow-sm py-2 px-3 mb-3">

              <a className="navbar-brand me-0" href="#">
                {state.company.logo ?
                  <img className="logo" src={state.company.logo} />
                  : <div></div>}

              </a>

              <div className="flex-grow-1 col-9 ps-3">

                <h1 className="mb-0 fs-3">{state.company.company}</h1>

              </div>
            </header>


            <div className="container-fluid">
              <div className="row">


                <main className="p-2">
                  <section className="content d-inline-block w-100">
                    <div className="container-fluid">
                      <div className="card card-default mb-3">
                        <div className="card-body">
                          <InvoiceTemplate data={state.invoice} />
                        </div>
                      </div>
                      <div className="d-flex">
                      <UiButton className="btn btn-primary" onClick={() => downloadPdf(state.invoice.id, state.invoice.invoice_id)} loading={loader} title="Download Invoice"></UiButton>
                      {state.company && state.company.pg ?
                      <UiButton className="btn btn-success ms-2" onClick={() => navigat('/quick-pay/'+state.invoice.cust_id+'?amount='+state.invoice.total)} title="Pay Online"></UiButton>
                      : ''}
                      </div>
                    </div>
                  </section>
                </main>

              </div>
            </div>
          </>
          : <BgLoader />}
      </>
    </div>
  );
};

export default ViewInvoice;
